window.chartVermoegensaufteilungMandant = {
	init: function () {
		this.chart = new Highcharts.Chart("chart_vermoegensaufteilung_mandant", {
			chart: {
				type: "pie",
				events: {
					render: function () {
						var chart = this,
							series = chart.series,
							allZeros = true
						for (var i = 0; i < series[0].data.length; i++) {
							if (series[0].data[i].y !== 0) {
								allZeros = false
							}
						}
						if (allZeros) {
							chart.showLoading("Keine Daten vorhanden")
						} else {
							chart.hideLoading()
						}
					},
				},
				// margin: [0, 0, 0, 0],
				// spacingTop: 0,
				// spacingBottom: 0,
				// spacingLeft: 0,
				// spacingRight: 0,
			},

			tooltip: {
				headerFormat: "",
				pointFormatter: function () {
					return `${this.name}<br/><b>${Highcharts.numberFormat(this.percentage, 0)}%</b>`
				},
				style: {
					fontSize: chartFontSizeMittel,
					textAlign: "center",
				},
			},

			// plotOptions: {
			// 	pie: {
			// 		size: "100%",
			// 	},
			// },

			series: this.chartdata(),
		})
	},

	update: function () {
		if (typeof this.chart !== "undefined") {
			this.chartdata().forEach(
				function (serie) {
					this.chart.get(serie.id).setData(serie.data, false)
				}.bind(this)
			)

			this.chart.redraw({ duration: chartAnimationDuration })
		}
	},

	chartdata: () => {
		const data = []

		// Liquidität
		const liquielement = document.querySelector(".vermoegensaufteilung_container [data-liqui]")
		liquibetrag = parseFloat(liquielement.dataset.liqui)

		if (liquibetrag > 0) {
			data.push({
				name: "Liquidität",
				y: Math.abs(liquibetrag),
				color: getGradientColor(farbeEinnahmen),
			})
		}

		// Kapitalanlagen
		const kapelement = document.querySelector(".vermoegensaufteilung_container [data-kapitalmandant]")
		kapbetrag = parseFloat(kapelement.dataset.kapitalmandant)

		if (kapbetrag > 0) {
			data.push({
				name: "Kapitalanlagen",
				y: Math.abs(kapbetrag),
				color: getGradientColor(kapitalanlagen),
			})
		}

		// Sonstige VM
		const svelement = document.querySelector(".vermoegensaufteilung_container [data-svmandant]")
		svbetrag = parseFloat(svelement.dataset.svmandant)

		if (svbetrag > 0) {
			data.push({
				name: "Sonstige Vermögenswerte",
				y: Math.abs(svbetrag),
				color: getGradientColor(farbeSonstigeVermoegenswerte),
			})
		}

		// Immobilien
		const immoelement = document.querySelector(".vermoegensaufteilung_container [data-immomandant]")
		immobetrag = parseFloat(immoelement.dataset.immomandant)

		if (immobetrag > 0) {
			data.push({
				name: "Immobilien",
				y: Math.abs(immobetrag),
				color: getGradientColor(farbeImmobilien),
			})
		}

		// Unternehmen
		const unternehmenelement = document.querySelector(".vermoegensaufteilung_container [data-unternehmenmandant]")
		unternehmenbetrag = parseFloat(unternehmenelement.dataset.unternehmenmandant)

		if (unternehmenbetrag > 0) {
			data.push({
				name: "Unternehmen",
				y: Math.abs(unternehmenbetrag),
				color: getGradientColor(farbeUnternehmen),
			})
		}

		return (series = [
			{
				id: "vermoegensaufteilung_mandant",
				data: data,
			},
		])
	},
}
